// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2245":"css/primevue-dark","4356":"fe/css/vendors","4427":"css/primevue-light","5612":"fe/css/main","8252":"css/app"}[chunkId] + ".css";
};